import { useRoutes } from "react-router-dom";
import Machine from "./Component/machine";
import MachineForm from "./Component/machineForm";

const MachineRoutes = () => {
  const routes = useRoutes([
    { path: "/", element: <Machine /> },
    { path: "add", element: <MachineForm /> },
    { path: "edit/:uuid", element: <MachineForm mode="edit" /> },
    { path: "view/:uuid", element: <MachineForm mode="view" /> },
  ]);
  return <>{routes}</>;
};
export default MachineRoutes;
